var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app-content"}},[_c('server'),_c('transition',{attrs:{"name":_vm.routerTransition,"mode":"out-in"}},[_c('div',{attrs:{"id":"app-content-padding"}},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }